// css
import "../../scss/pages/taxonomy-lifejournal-category.scss";

// npm
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

// utils
import foundation from "../_utils/foundation";
foundation();

// libs
import ScrollObserver from "../_libs/ScrollObserver";
import HeaderSideNav from "../_libs/HeaderSideNav";
import Ranking from "../_libs/Ranking";

document.addEventListener("DOMContentLoaded", () => {
	HeaderSideNav();
	Ranking();
	setTimeout(function () {
		document.querySelectorAll(".js-first-animation").forEach((element) => {
			element.classList.add("is-active");
		});
	}, 200);

	setTimeout(function () {
		document.querySelectorAll(".js-fv").forEach((element) => {
			element.classList.add("is-active");
		});
	}, 200);

	const scrollObserver_block = new ScrollObserver({
		target: ".js-block-target",
		addClass: "is-active",
		once: true,
		option: {
			rootMargin: "0px 0px -30% 0px",
		},
	});
	// 監視開始;
	scrollObserver_block.init();

	const posts = gsap.utils.toArray(".js-post");

	// メインのタイムラインを作成
	const mainTl = gsap.timeline({
		scrollTrigger: {
			trigger: ".js-post-trigger",
			start: "top 90%",
			toggleActions: "play none none none",
		},
	});

	posts.forEach((post, index) => {
		const postImage = post.querySelector(".js-post-image");
		const tl = gsap.timeline();
		tl.to(post, {
			opacity: 1,
			duration: 1.2,
			ease: "power2.out",
		}).to(
			postImage,
			{
				filter: "saturate(1)",
				duration: 1,
				ease: "power3.out",
			},
			">"
		);

		mainTl.add(tl, index * 0.15); // 0.15秒ごと
	});

	const rankingPosts = document.querySelectorAll(".js-ranking-post");
	gsap.to(rankingPosts, {
		opacity: 1,
		duration: 1.8,
		stagger: 0.25,
		ease: "power2.out",
		scrollTrigger: {
			trigger: ".js-ranking-post-trigger",
			start: "top 90%",
			toggleActions: "play none none none",
		},
	});

	const hoverPosts = document.querySelectorAll(".js-post");

	hoverPosts.forEach((hoverPost, index) => {
		const postIndex = index + 1;

		const links = document.querySelectorAll(`.js-journal-link--${postIndex}`);

		links.forEach((link) => {
			link.addEventListener("mouseenter", () => {
				document.querySelector(`.js-post--${postIndex}`).classList.add("is-hover");
			});

			link.addEventListener("mouseleave", () => {
				document.querySelector(`.js-post--${postIndex}`).classList.remove("is-hover");
			});
		});
	});
});
window.addEventListener("load", () => {});
